/**
 * 음식 취향 MBTI 타입 설명 (새 축 시스템: S/M, A/O, P/C, A/O)
 * 축 1: S(Strong) vs M(Mild), 축 2: A(Ambiance) vs O(Optimized), 
 * 축 3: P(Premium) vs C(Cost Effective), 축 4: A(All Together) vs O(On My Own)
 */

export const MBTI_TYPE_DESCRIPTIONS = {
  "SAPA": {
    "emoji": "🔥",
    "name": "도파민 추구 미식회장",
    "catchphrase": "인생 뭐 있어? 오늘 밤은 화려하게!",
    "description": "맵고 짜고 비싼 음식을 힙한 곳에서 친구들과 즐깁니다. 스트레스는 자극으로 풉니다.",
    "recommendations": ["파인다이닝 레스토랑", "프리미엄 바", "고급 한정식"],
    "recommend": [
      "마라 훠궈 무한리필: 가장 매운 단계 필수",
      "프리미엄 다이닝 펍: 조명 화려하고 음악 빵빵한 곳",
      "킹크랩/랍스터: 비주얼 압도적인 메뉴"
    ],
    "avoid": [
      "슴슴한 사찰음식 전문점 (무맛이라 싫음)",
      "조용히 책 읽어야 하는 북카페",
      "플레이팅 대충 나오는 기사식당"
    ]
  },
  "SAPO": {
    "emoji": "🍷",
    "name": "나를 위한 마라카세",
    "catchphrase": "내 취향은 소중하니까.",
    "description": "혼자서도 최고급으로 즐깁니다. 자극적인 맛을 우아하고 프라이빗하게 즐기는 고독한 미식가입니다.",
    "recommendations": ["조용한 고급 레스토랑", "프리미엄 와인바", "품격 있는 일식당"],
    "recommend": [
      "1인 셰프 바(Bar): 독한 위스키와 안주",
      "프리미엄 혼고기: 최고급 특수부위",
      "매운맛 오마카세: 퓨전 다이닝"
    ],
    "avoid": [
      "시끄러운 회식 장소 (기 빨림)",
      "가성비 무한리필집 (질 떨어져서 싫음)",
      "합석해야 하는 시장 국밥집"
    ]
  },
  "SACA": {
    "emoji": "📸",
    "name": "가성비 핫플 사냥꾼",
    "catchphrase": "야, 여기 인스타에서 난리 났대!",
    "description": "힙하고 맛도 있는데 가격까지 착한 곳을 찾아냅니다. 웨이팅도 친구와 함께라면 즐겁습니다.",
    "recommendations": ["가성비 좋은 맛집", "분위기 좋은 술집", "동네 인기 맛집"],
    "recommend": [
      "을지로 노포: 감성 터지는 야장 삼겹살",
      "대학가 퓨전 포차: 안주 킬러들의 성지",
      "줄 서는 떡볶이 맛집: 맵단짠의 정석"
    ],
    "avoid": [
      "비싸기만 하고 맛없는 호텔 뷔페",
      "인테리어 구린 동네 백반집",
      "정적 흐르는 격식 있는 식당"
    ]
  },
  "SACO": {
    "emoji": "🤳",
    "name": "프로 혼밥 인스타그래머",
    "catchphrase": "혼자 먹어도 느낌 있게.",
    "description": "분위기 좋은 창가 자리에서 자극적인 맛을 즐기며 SNS에 올릴 사진을 찍습니다.",
    "recommendations": ["바 테이블 라멘집", "감성 타코 가게", "수제버거 맛집"],
    "recommend": [
      "바 테이블 라멘집: 매운 돈코츠 라멘",
      "감성 타코 가게: 혼자서 타코 3개 순삭",
      "수제버거 맛집: 육즙 가득 패티"
    ],
    "avoid": [
      "4인 테이블만 있는 패밀리 레스토랑",
      "조명 너무 밝은 김밥천국",
      "플레이팅 없는 기사식당"
    ]
  },
  "SOPA": {
    "emoji": "⚡",
    "name": "속전속결 맛집 파괴자",
    "catchphrase": "맛있는 건 먹고 싶은데, 기다리는 건 질색이야.",
    "description": "돈을 더 내더라도 예약 확정이 되고, 서비스가 빠르며 맛도 확실한 곳을 선호합니다.",
    "recommendations": ["구워주는 고깃집", "중식 코스 요리", "호텔 뷔페 룸"],
    "recommend": [
      "구워주는 고깃집: 손 하나 까딱 안 해도 됨",
      "중식 코스 요리: 예약 필수, 빠른 서빙",
      "호텔 뷔페 룸: 동선 짧고 음식 다양"
    ],
    "avoid": [
      "웨이팅 2시간 필수인 인스타 핫플",
      "직접 재료 손질해서 먹는 샤브샤브",
      "주차장 없는 골목 식당"
    ]
  },
  "SOPO": {
    "emoji": "🛵",
    "name": "1인분 10만원 배달러",
    "catchphrase": "집이 최고야, 맛은 포기 못 해.",
    "description": "가장 편한 옷차림으로 집에서 최고급 요리를 즐깁니다. 배달비 따위는 신경 쓰지 않습니다.",
    "recommendations": ["특상 우나기동", "호텔 투고 박스", "프리미엄 모듬회"],
    "recommend": [
      "특상 우나기동(장어덮밥): 배달로 즐기는 보양식",
      "호텔 투고(To-go) 박스: 퀄리티 보장",
      "프리미엄 모듬회: 두툼하게 썬 회"
    ],
    "avoid": [
      "브레이크 타임 걸리는 식당",
      "직접 가서 줄 서야 먹을 수 있는 곳",
      "조리 시간이 오래 걸리는 슬로우 푸드"
    ]
  },
  "SOCA": {
    "emoji": "🍖",
    "name": "무한리필 원정대장",
    "catchphrase": "양 많고, 맛있고, 싸고!",
    "description": "전투적으로 먹습니다. 격식 따위는 필요 없고 배부르고 자극적인 게 최고입니다.",
    "recommendations": ["마라탕", "고기 뷔페", "기사식당"],
    "recommend": [
      "마라탕 & 꿔바로우: 재료 듬뿍 담아도 저렴",
      "고기 뷔페: 눈치 안 보고 고기 흡입",
      "기사식당 제육볶음: 맛과 스피드 보장"
    ],
    "avoid": [
      "양 쥐꼬리만 한 파인다이닝",
      "음식 나오는 데 30분 걸리는 곳",
      "조용히 먹어야 하는 분위기"
    ]
  },
  "SOCO": {
    "emoji": "🏪",
    "name": "편의점 만렙 귀차니스트",
    "catchphrase": "귀찮지만 맛없는 건 싫어.",
    "description": "식사는 생존입니다. 빠르고 싸게 해결하되, 맵고 짠 자극은 포기할 수 없습니다.",
    "recommendations": ["편의점", "패스트푸드", "컵밥"],
    "recommend": [
      "불닭볶음면 + 삼각김밥: 편의점 꿀조합",
      "패스트푸드 신메뉴: 키오스크로 1분 컷",
      "컵밥/도시락: 설거지 필요 없음"
    ],
    "avoid": [
      "주문 방식 복잡한 서브웨이 (커스텀 귀찮음)",
      "코스 요리 (너무 길어)",
      "직원이 말 거는 식당"
    ]
  },
  "MAPA": {
    "emoji": "🥗",
    "name": "청담동 브런치 모임장",
    "catchphrase": "건강하고 예쁘게, 우아하게.",
    "description": "자극적이지 않은 건강한 맛과 고급스러운 분위기를 선호합니다. 식사는 대화의 연장선입니다.",
    "recommendations": ["고급 레스토랑", "브런치 카페", "프리미엄 디저트 카페"],
    "recommend": [
      "호텔 애프터눈 티 세트: 사진 필수, 맛도 깔끔",
      "평양냉면 맛집: 슴슴한 맛의 미학",
      "비건 파인다이닝: 속이 편한 코스 요리"
    ],
    "avoid": [
      "맵고 짜고 위생 안 좋은 노포",
      "음악 소리 너무 큰 펍",
      "빨간 국물 튀는 전골집"
    ]
  },
  "MAPO": {
    "emoji": "🧘",
    "name": "고독한 미슐랭 탐험가",
    "catchphrase": "재료 본연의 맛을 느껴봐.",
    "description": "조용한 곳에서 셰프의 정성이 담긴 요리를 음미합니다. 시끄러운 건 질색입니다.",
    "recommendations": ["스시 오마카세", "프리미엄 솥밥", "티 오마카세"],
    "recommend": [
      "스시 오마카세: 흰 살 생선의 풍미",
      "프리미엄 솥밥: 갓 지은 밥맛",
      "티(Tea) 오마카세: 차와 다과"
    ],
    "avoid": [
      "시장통 국밥집 (너무 소란스러움)",
      "간이 센 프랜차이즈 식당",
      "합석 권유하는 식당"
    ]
  },
  "MACA": {
    "emoji": "🧸",
    "name": "연남동 감성 지킴이",
    "catchphrase": "아기자기하고 귀여운 게 좋아.",
    "description": "예쁘고 감성 넘치는 공간에서 부담 없는 가격의 브런치나 디저트를 즐깁니다.",
    "recommendations": ["일본 가정식", "주택 개조 카페", "과일 산도"],
    "recommend": [
      "일본 가정식: 정갈한 한 상 차림",
      "주택 개조 카페: 포토존 많은 곳",
      "과일 산도 & 푸딩: 눈으로 먼저 먹는 맛"
    ],
    "avoid": [
      "투박한 아재 입맛 식당",
      "욕쟁이 할머니 식당",
      "조명 어두운 술집"
    ]
  },
  "MACO": {
    "emoji": "🌿",
    "name": "숨은 골목 맛집 발굴러",
    "catchphrase": "소소하지만 확실한 행복.",
    "description": "사람 많은 핫플보다는 동네의 조용하고 따뜻한 가게를 선호합니다.",
    "recommendations": ["동네 베이커리", "조용한 찻집", "수제 요거트"],
    "recommend": [
      "동네 작은 베이커리: 갓 구운 소금빵",
      "조용한 찻집: 창밖 보며 멍때리기",
      "수제 요거트 가게: 건강한 한 끼"
    ],
    "avoid": [
      "단체 손님 많은 고깃집",
      "웨이팅 있는 인스타 맛집",
      "향이 강한 마라탕집"
    ]
  },
  "MOPA": {
    "emoji": "🧭",
    "name": "실패 없는 맛집 네비게이션",
    "catchphrase": "깔끔하고, 빠르고, 맛있게.",
    "description": "비즈니스 미팅이나 가족 모임에 적합한, 호불호 없이 누구나 만족할 고급 식당을 찾습니다.",
    "recommendations": ["룸 있는 일식", "모던 한식", "샤브샤브 뷔페"],
    "recommend": [
      "룸 있는 일식 코스: 프라이빗하고 정갈함",
      "모던 한식 반상: 1인 1상으로 깔끔하게",
      "샤브샤브 뷔페: 취향껏 골라 먹기"
    ],
    "avoid": [
      "호불호 갈리는 향신료(고수 등) 전문점",
      "음식 늦게 나오는 곳",
      "주차 불편한 곳"
    ]
  },
  "MOPO": {
    "emoji": "💼",
    "name": "성공한 자의 간편식",
    "catchphrase": "내 몸은 자산이다.",
    "description": "시간은 금입니다. 빠르고 간편하게 먹지만, 영양 성분과 퀄리티는 절대 타협하지 않습니다.",
    "recommendations": ["프리미엄 샐러드", "백화점 도시락", "고급 단백질 쉐이크"],
    "recommend": [
      "프리미엄 샐러드 구독: 탄단지 완벽 비율",
      "백화점 식품관 도시락: 검증된 맛",
      "고급 단백질 쉐이크: 바쁠 땐 마시는 걸로"
    ],
    "avoid": [
      "줄 서서 사 먹는 길거리 음식",
      "직접 요리해야 하는 밀키트 (귀찮음)",
      "기름진 패스트푸드"
    ]
  },
  "MOCA": {
    "emoji": "🍚",
    "name": "기사식당 섭외 담당",
    "catchphrase": "밥은 역시 집밥 스타일이지.",
    "description": "편안한 분위기에서 부담 없이 배불리 먹을 수 있는 백반집을 사랑합니다.",
    "recommendations": ["기사식당", "콩나물 국밥", "칼국수"],
    "recommend": [
      "기사식당 백반: 불백, 생선구이",
      "24시간 콩나물 국밥: 빠르고 든든함",
      "칼국수 & 수제비: 후루룩 먹기 좋음"
    ],
    "avoid": [
      "양 적고 비싼 카페 브런치",
      "옷 차려입고 가야 하는 레스토랑",
      "향신료 강한 외국 음식"
    ]
  },
  "MOCO": {
    "emoji": "🥪",
    "name": "삼각김밥 소믈리에",
    "catchphrase": "배만 채우면 돼, 자극적인 건 싫어.",
    "description": "식사는 미션 클리어하듯이. 빠르고 간단하게, 속 편한 음식을 선호합니다.",
    "recommendations": ["계란 샌드위치", "맑은 우동", "미숫가루"],
    "recommend": [
      "계란 샌드위치: 부드럽고 간편함",
      "맑은 우동/국수: 자극 없는 국물",
      "미숫가루/두유: 마시는 식사"
    ],
    "avoid": [
      "매운 떡볶이 (속 쓰림)",
      "먹기 불편한 대형 수제버거",
      "뜨거운 뚝배기 음식 (식혀 먹기 귀찮음)"
    ]
  }
};

/**
 * MBTI 타입 정보를 가져옵니다
 * @param {string} mbtiType - MBTI 타입 (예: "SQAF")
 * @returns {object} 타입 정보 (name, description, recommendations)
 */
export const getMBTIInfo = (mbtiType) => {
  return MBTI_TYPE_DESCRIPTIONS[mbtiType] || {
    name: "알 수 없음",
    description: "타입 정보를 찾을 수 없습니다",
    recommendations: []
  };
};

